import '../styles/WinCard.css';

function formatMinutes(total) {
  const mins = Math.round(Number(total) || 0);
  if (mins <= 0) return '—';
  const h = Math.floor(mins / 60);
  const m = mins % 60;
  if (h === 0) return `${m}m`;
  if (m === 0) return `${h}h`;
  return `${h}h ${m}m`;
}

function stripHtml(html) {
  if (!html) return '';
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return (doc.body.textContent || '').replace(/\s+/g, ' ').trim();
}

function formatDate(iso) {
  if (!iso) return '';
  return new Date(iso).toLocaleDateString('en-US', {
    month: 'short', day: 'numeric', year: 'numeric',
  });
}

export default function WinCard({ win, onClick, liked, likeCount, onLike }) {
  // "Time Spent" is retired from new submissions but retained on historical rows.
  // Capacity and benefits render independently so a combined win shows both.
  const hasSpent = win.timeSpentMinutes > 0;
  const hasCapacity = win.timeSavedMinutes > 0;

  return (
    <div className="win-card" onClick={onClick} style={{ cursor: 'pointer' }}>
      <div className="win-card-header">
        {win.department && <span className="dept-badge">{win.department}</span>}
        <span className="frequency-badge">{win.frequency}</span>
      </div>
      <p className="win-task">{win.task}</p>
      {win.howDidYouUseAI && (
        <p className="win-how">{stripHtml(win.howDidYouUseAI)}</p>
      )}
      {(hasSpent || hasCapacity) && (
        <div className="win-stats">
          {hasSpent && (
            <div className="win-stat">
              <span className="stat-value">{formatMinutes(win.timeSpentMinutes)}<span className="stat-unit"> spent</span></span>
            </div>
          )}
          {hasSpent && hasCapacity && <div className="win-arrow">→</div>}
          {hasCapacity && (
            <div className="win-stat highlight">
              <span className="stat-value">{formatMinutes(win.timeSavedMinutes)}<span className="stat-unit"> capacity</span></span>
            </div>
          )}
        </div>
      )}
      {win.benefits && <p className="win-benefits">{stripHtml(win.benefits)}</p>}
      <div className="win-footer">
        <span className="win-author">{win.onBehalfOf || win.submittedBy}</span>
        <div className="win-footer-right">
          <span className="win-date">{formatDate(win.created)}</span>
          <button
            className={`like-btn ${liked ? 'liked' : ''}`}
            onClick={onLike}
            aria-label={liked ? 'Unlike' : 'Like'}
            title={liked ? 'Remove from favorites' : 'Add to favorites'}
          >
            {liked ? '♥' : '♡'}
            {likeCount > 0 && <span className="like-count">{likeCount}</span>}
          </button>
        </div>
      </div>
    </div>
  );
}
